import { Component, Input, ViewChild } from '@angular/core';

import { CheckboxInput } from '../../form-controls';
import { branding, domain, shortBranding } from '../../../common/text';

import * as emails from 'common/emails.json';

declare const GAMING: boolean;

@Component({
  selector: 'terms-conditions-form',
  styleUrls: ['./terms-conditions-form.component.scss'],
  templateUrl: './terms-conditions-form.component.pug'
})
export class TermsConditionsForm {
  @Input() public showHighlightedError: boolean;
  @ViewChild(CheckboxInput, { static: true }) public checkbox: CheckboxInput;
  public today: Date = new Date();
  public brand: string = branding[GAMING ? 'gaming' : 'pfm']
  public abv: string = shortBranding[GAMING ? 'gaming' : 'pfm']
  public domain: string = domain[GAMING ? 'gaming' : 'pfm']
  public url: string = `www.${domain[GAMING ? 'gaming' : 'pfm'].toLowerCase()}`
  public dataPrivacy: string = emails.dataPrivacy;
  public inquiries: string = emails.inquiries;
  // public note: string = GAMING ? "Patch Notes collects and process your personal data to provide aggregated feedback to its clients on the games and Creative Content-related discussion or activities you're being invited to. This processing is further described in our Privacy Policy below. Please exit WITHOUT submitting, if you don't wish to consent" : undefined
  public content: Record<string, string> = GAMING ? {
    full: '"works-in-progress" creative content that may be associated with games and other media',
    single: 'viewing "works-in-progress" creative content that may be associated with games and other media',
    plural: 'viewings of "works-in-progress" creative content that may be associated with games and other media'
  } : {
    full: 'new and upcoming movies',
    single: 'screening',
    plural: 'screenings'
  }
  public contentType: Record<string, string> = GAMING ? {
    long: 'viewings of "works-in-progress" creative content that may be associated with games and other media (the "Creative Content")',
    short: 'viewing of the Creative Content',
    plural: 'viewings of the Creative Content'
  } : {
    long: 'movie screening',
    short: 'movie screening',
    plural: 'movie screenings'
  }

  public valid() {
    return this.value();
  }

  public value() {
    return this.checkbox.value;
  }
}
